import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { GeoData } from '../types/geo';

export interface GeoState {
  geo: GeoData | null;
}

const initialState: GeoState = {
  geo: null,
};

const geoSlice = createSlice({
  name: 'geo',
  initialState,
  reducers: {
    setGeo(state, action: PayloadAction<GeoData>) {
      state.geo = action.payload;
    },
    clearGeo(state) {
      state.geo = null;
    },
  },
});

export const { setGeo, clearGeo } = geoSlice.actions;
export default geoSlice.reducer;
